module.exports = __webpack_public_path__ + "img/quick_stats-1.6eadb2c7.svg";